/**
 * Abortable fetch for the flat list of publications in an entity, used by the
 * StoryList "add to publication" flow.
 *
 * Inlined from the retired `storyListEffects.getAllPublicationsList`
 * (compose-app). Same GraphQL document (`getAllPublicationsInEntity`) and
 * cookie-session auth via the stories-service proxy. Debounce + abort are
 * owned by the caller; this helper just runs the request.
 */

import { IPublication } from '@opengov/stories-shared/types';

import { postQueryWithSignal } from '../../../effects/publications/postQuery';
import { getAllPublicationsInEntity } from '../../../graphQL/queries/listQueries';

export async function fetchAllPublicationsInEntity(
  entityId: number,
  controller: AbortController
): Promise<IPublication[] | undefined> {
  const res = await postQueryWithSignal(getAllPublicationsInEntity, { entityId }, controller);
  return res?.publications;
}
